import * as React from "react";
import { Row, Col, Button, notification } from "antd";
import CreditCardRegisteredList from "../CreditCardRegisteredList";
import { CreditCardRegistrationFormHandler } from "../CreditCardRegistrationFormHandler";
import Form, { FormComponentProps } from "antd/lib/form";
import { RouteComponentProps, withRouter } from "react-router";
import { ICreditCardRegistrationDto, IConfirmCreditCardRegistrationRequestBody, ConfirmCreditCardRegistrationRequestBody, AddressDto, IAddressDto } from "Core/Api/Payment/Api";
import CreditCardRegistrationForm from "../CreditCardRegistrationForm";
import UpdateCreditCardForm from "../UpdateCreditCardForm";
import CreditCardConfirmation from "../CreditCardConfirmation";
import AuthContext from "Context/AuthContext";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
    regClicked: boolean,
    cardDetails: Array<ICreditCardRegistrationDto>
    registered: boolean,
    confirmClicked: boolean,
    editClicked: boolean,
    billingAddress: IAddressDto,
    regIdEdit: number;
    regIdConfirm: number;
    reload: boolean;
}

class BaseCreditCardOverview extends React.Component<Props, State> {
    creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props)

        this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
        this.DisplayCardRegistrationForm = this.DisplayCardRegistrationForm.bind(this);
        this.CloseRegistrationForm = this.CloseRegistrationForm.bind(this);
        this.DisplayCardEditForm = this.DisplayCardEditForm.bind(this);
        this.getCardDetails = this.getCardDetails.bind(this);
        this.getBillAddress = this.getBillAddress.bind(this);
        this.getConfirmId = this.getConfirmId.bind(this);

        this.state = {
            regClicked: false,
            cardDetails: [],
            registered: false,
            confirmClicked: false,
            editClicked: false,
            regIdEdit: 0,
            regIdConfirm: 0,
            reload: false,

            billingAddress:
            {
                addressLine1: '',
                addressLine2: '',
                firstName: '',
                middleName: '',
                lastName: '',
                city: '',
                countryCode: '',
                telephone: ''
            }
        }
    }

    getCardDetails(cardDetails: Array<ICreditCardRegistrationDto>) {
        this.setState({ cardDetails: cardDetails })
    }

    getBillAddress(regId: number) {
        this.setState({ regIdEdit: regId });
        this.state.cardDetails.map(card => {
            if (regId !== undefined && regId == card.id) {
                if (card.billingAddress !== undefined) {
                    var i;
                    for (i in card.billingAddress) {
                        this.setState({ billingAddress: card.billingAddress })
                    }
                }
            }
        })
        this.DisplayCardEditForm();
    }

    getConfirmId(regId: number) {
        this.setState({ regIdEdit: regId });
    }

    componentDidMount() {
    }


    //display form to register a new credit card on click
    DisplayCardRegistrationForm = () => {
        this.setState({ regClicked: true })
    }
    //close form to register a new credit card on click
    CloseRegistrationForm = () => {
        this.setState({ regClicked: !this.state.regClicked })
    }

    //display form to edit registerd credit card billing address on click
    DisplayCardEditForm = () => {
        this.setState({ editClicked: true })
    }
    //close form to to edit registerd credit card billing address on click
    CloseCardEditForm = () => {
        this.setState({ editClicked: false })
    }

    render() {
        var page

        if (this.state.regClicked && !this.state.editClicked) {
            page = <>
                <Row>
                    <Col>
                        {/* for registration form */}
                        <CreditCardRegistrationForm
                            cancelButton={this.CloseRegistrationForm}
                            registered={this.CloseRegistrationForm} />
                    </Col>
                </Row></>
        } else if (!this.state.regClicked && !this.state.editClicked) {
            page = <>
                <Row>
                    {/* list of card registered */}
                    <Col>
                        <CreditCardRegisteredList
                            DisplayCardRegistrationForm={this.DisplayCardRegistrationForm}
                            card={this.getCardDetails}
                            getUpdateDetails={this.getBillAddress}
                            chargeButton={this.getConfirmId}
                            reloadList={this.CloseCardEditForm}
                        />
                    </Col>
                </Row>
            </>
        } else if (!this.state.regClicked && this.state.editClicked) {
            page = <Row>
                {/* Edit credit card billing address */}
                <Col>
                    <UpdateCreditCardForm
                        billingAddress={this.state.billingAddress}
                        regId={this.state.regIdEdit}
                        cancelButton={this.CloseCardEditForm}
                        updated={this.CloseCardEditForm} />
                </Col>
            </Row>
        }


        return (
            <>
                {page}
            </>
        )
    }
}


const CreditCardOverviewWithoutRouter = Form.create<Props>({
    name: 'UpdateUserProfileForm',
})(BaseCreditCardOverview);

const CreditCardOverview = withRouter(CreditCardOverviewWithoutRouter);

export default CreditCardOverview;